import cn from 'classnames';
import { ReactNode } from 'react';
import styles from './container.module.scss';

export interface IContainerProps {
  children: ReactNode;
  color?: 'none' | 'h-dark-gradient' | 'dark' | 'black' | 'v-green-fade';
  radius?: 'none' | 'sm' | 'md' | 'lg';
  className?: string;
}

const Container = ({
  children,
  color = 'none',
  radius = 'none',
  className,
}: IContainerProps): JSX.Element => {
  const classes = cn(styles.container, className, {
    [styles[`container-color-${color}`]]: color,
    [styles[`container-radius-${radius}`]]: radius,
  });

  return <div className={classes}>{children}</div>;
};

export default Container;
